var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "36.97333333333334 170.94527346938779 554.8266666666666 294.1347265306123",
    width: 550.83,
    height: 290.13,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M219.31 408.75C213.33 408.75 208.64 404.05 208.64 398.08C208.64 392.11 213.33 387.41 219.31 387.41C241.71 387.41 420.91 387.41 443.31 387.41C449.28 387.41 453.97 392.11 453.97 398.08C453.97 404.05 448.85 408.75 442.88 408.75C398.17 408.75 241.66 408.75 219.31 408.75Z",
    id: "b2yVVHK6de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.84 408.75C541.87 408.75 537.17 404.05 537.17 398.08C537.17 392.11 541.87 387.41 547.84 387.41C549.08 387.41 558.98 387.41 560.21 387.41C564.48 387.41 567.47 384 567.47 380.16C567.47 372.31 567.47 309.5 567.47 301.65C567.47 292.69 560.21 285.01 550.83 285.01C515.37 285.01 231.72 285.01 196.27 285.01C192.43 285.01 189.01 282.88 186.88 279.47C185.17 276.05 185.17 272.21 186.88 268.8C189.4 264.62 209.54 231.17 212.05 226.99C226.56 201.81 259.41 202.67 264.11 202.67C274.47 202.67 357.42 202.67 367.79 202.67C366.51 201.39 365.65 200.11 364.37 198.83C358.83 192.43 349.87 192.43 349.87 192.43C329.94 192.43 170.54 192.43 150.61 192.43C139.09 192.85 132.27 196.69 128 201.39C134.78 201.39 189.06 201.39 195.84 201.39C199.68 201.39 203.09 203.52 204.8 206.51C206.93 209.92 206.93 213.76 205.23 217.17C201.9 223.4 175.27 273.24 171.95 279.47C170.24 282.88 166.4 285.01 162.56 285.01C158.26 285.01 136.79 285.01 98.13 285.01C98.13 325.97 98.13 348.73 98.13 353.28C98.13 365.65 104.96 377.17 115.63 383.15C120.75 386.13 122.45 392.53 119.89 397.65C117.33 402.77 110.51 404.48 105.39 401.92C87.89 392.11 76.8 373.76 76.8 353.71C76.8 345.81 76.8 282.67 76.8 274.77C76.8 268.8 81.49 264.11 87.47 264.11C92.05 264.11 114.94 264.11 156.16 264.11L177.92 223.15C137.47 223.15 115 223.15 110.51 223.15C107.52 223.15 104.53 221.87 102.4 219.31C100.27 216.75 99.41 213.76 99.84 210.77C101.97 197.55 115.63 172.8 150.19 171.95C170.11 171.95 329.51 171.95 349.44 171.95C351.15 171.95 368.64 171.52 380.59 185.6C389.55 196.27 398.08 206.93 398.51 207.36C401.07 210.77 401.49 215.04 399.79 218.45C398.08 221.87 394.24 224.43 390.4 224.43C377.73 224.43 276.35 224.43 263.68 224.43C263.25 224.43 263.25 224.43 262.83 224.43C262.83 224.43 238.93 223.15 230.4 238.08C229.38 239.79 224.26 248.32 215.04 263.68C416.51 263.68 528.44 263.68 550.83 263.68C571.73 263.68 588.8 280.75 588.8 301.65C588.8 309.5 588.8 372.31 588.8 380.16C588.8 395.95 576 408.75 560.21 408.75C557.74 408.75 549.08 408.75 547.84 408.75Z",
    id: "aKVP0Qv7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.57 279.89C412.12 273.83 384.47 225.37 381.01 219.31C378.03 214.19 379.73 207.79 384.85 204.8C389.97 201.81 396.37 203.52 399.36 208.64C402.82 214.7 430.46 263.17 433.92 269.23C436.91 274.35 435.2 280.75 430.08 283.73C428.37 284.59 426.67 285.44 424.96 285.44C421.12 285.44 417.71 283.31 415.57 279.89Z",
    id: "aENiF5RnG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.29 359.68C49.07 359.68 37.97 349.01 37.97 335.36C37.97 328.19 37.97 270.85 37.97 263.68C37.97 250.45 48.64 239.36 62.29 239.36C63.45 239.36 72.66 239.36 73.81 239.36C87.04 239.36 98.13 250.03 98.13 263.68C98.13 270.85 98.13 328.19 98.13 335.36C98.13 348.59 87.04 359.68 73.81 359.68C71.51 359.68 63.45 359.68 62.29 359.68ZM59.31 263.68C59.31 270.85 59.31 328.19 59.31 335.36C59.31 337.07 60.59 338.35 62.29 338.35C63.45 338.35 72.66 338.35 73.81 338.35C75.52 338.35 76.8 337.07 76.8 335.36C76.8 328.19 76.8 270.85 76.8 263.68C76.8 261.97 75.52 260.69 73.81 260.69C73.05 260.69 69.21 260.69 62.29 260.69C60.3 261.55 59.31 262.54 59.31 263.68Z",
    id: "a5ED63ILfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.47 285.44C81.49 285.44 76.8 280.75 76.8 274.77C76.8 272.6 76.8 255.19 76.8 253.01C76.8 206.08 118.19 181.76 119.89 180.91C124.59 178.35 130.56 179.63 133.55 183.89C136.96 188.16 136.11 194.13 132.27 197.97C132.01 198.23 130.73 199.51 128.43 201.81C168.87 201.81 191.35 201.81 195.84 201.81C199.68 201.81 203.09 203.95 204.8 206.93C206.93 210.35 206.93 214.19 205.23 217.6C201.9 223.83 175.27 273.66 171.95 279.89C170.24 282.88 166.4 285.44 162.56 285.44C147.54 285.44 94.98 285.44 87.47 285.44ZM156.16 264.11L177.92 223.15C135.42 223.15 111.82 223.15 107.09 223.15C101.97 231.25 98.13 241.07 98.13 253.01C98.13 253.75 98.13 257.45 98.13 264.11L156.16 264.11Z",
    id: "b4VC4EoFm"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.23 348.16C199.25 348.16 194.56 343.47 194.56 337.49C194.56 331.52 199.25 326.83 205.23 326.83C229.93 326.83 427.56 326.83 452.27 326.83C458.24 326.83 462.93 331.52 462.93 337.49C462.93 343.47 458.24 348.16 452.27 348.16C402.86 348.16 229.93 348.16 205.23 348.16Z",
    id: "a8TIREh0L"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.28 340.48C576.71 340.45 573.87 340.31 568.75 340.05C537.77 340.05 520.56 340.05 517.12 340.05C514.13 340.05 511.57 338.77 509.44 336.64C507.31 334.51 506.45 331.52 506.45 328.96C506.45 328.96 506.45 324.27 506.45 311.47C506.03 281.6 529.49 266.24 530.35 265.81C531.63 264.96 533.33 264.11 535.04 264.11C552.96 262.4 567.04 266.24 576.43 275.2C588.37 285.87 588.8 300.37 588.8 301.65C588.8 304.47 588.8 327 588.8 329.81C588.8 332.8 587.52 335.79 585.39 337.49C583.68 339.63 581.12 340.48 578.13 340.48C577.71 340.48 577.71 340.48 577.28 340.48ZM567.47 318.72C567.47 308.48 567.47 302.79 567.47 301.65C567.47 301.65 567.04 295.25 561.92 290.56C557.23 286.29 549.55 284.59 539.73 285.01C535.89 288.43 527.36 297.39 527.36 311.04C527.79 314.03 527.79 316.59 527.79 318.72C533.08 318.72 546.3 318.72 567.47 318.72Z",
    id: "aIkRBnP6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.07 402.35C433.07 369.49 459.95 342.61 492.8 342.61C525.65 342.61 552.53 369.49 552.53 402.35C552.53 435.2 526.08 462.08 492.8 462.08C459.95 462.08 433.07 435.2 433.07 402.35ZM454.4 401.92C454.4 422.83 471.89 440.32 492.8 440.32C513.71 440.32 531.2 422.83 531.2 401.92C531.2 381.01 514.13 363.52 492.8 363.52C471.47 363.52 454.4 381.01 454.4 401.92Z",
    id: "h1tJ91XJB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.65 402.35C461.65 385.28 475.73 371.2 492.8 371.2C498.77 371.2 503.47 375.89 503.47 381.87C503.47 387.84 498.77 392.53 492.8 392.53C487.25 392.53 482.99 396.8 482.99 402.35C482.99 407.89 487.25 412.16 492.8 412.16C498.35 412.16 502.61 407.89 502.61 402.35C502.61 396.37 507.31 391.68 513.28 391.68C519.25 391.68 523.95 396.37 523.95 402.35C524.37 419.41 510.29 433.49 492.8 433.49C475.73 433.49 461.65 419.41 461.65 402.35Z",
    id: "euyctOFIE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67 402.35C106.67 369.49 133.55 342.61 166.4 342.61C199.25 342.61 226.13 369.49 226.13 402.35C226.13 435.2 199.68 462.08 166.4 462.08C133.55 462.08 106.67 435.2 106.67 402.35ZM128 401.92C128 422.83 145.49 440.32 166.4 440.32C187.73 440.32 204.8 422.83 204.8 401.92C204.8 381.01 187.73 363.52 166.4 363.52C145.07 363.52 128 381.01 128 401.92Z",
    id: "b2gLYSN5r0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.25 402.35C135.25 385.28 149.33 371.2 166.4 371.2C172.37 371.2 177.07 375.89 177.07 381.87C177.07 387.84 172.37 392.53 166.4 392.53C160.85 392.53 156.59 396.8 156.59 402.35C156.59 407.89 160.85 412.16 166.4 412.16C171.95 412.16 176.21 407.89 176.21 402.35C176.21 396.37 180.91 391.68 186.88 391.68C192.85 391.68 197.55 396.37 197.55 402.35C197.97 419.41 183.89 433.49 166.4 433.49C149.33 433.49 135.25 419.41 135.25 402.35Z",
    id: "c2EgNVXu5r"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2yVVHK6de",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2yVVHK6de",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aKVP0Qv7",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aKVP0Qv7",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aENiF5RnG",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aENiF5RnG",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5ED63ILfc",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5ED63ILfc",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4VC4EoFm",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4VC4EoFm",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8TIREh0L",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a8TIREh0L",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aIkRBnP6f",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aIkRBnP6f",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h1tJ91XJB",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h1tJ91XJB",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#euyctOFIE",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#euyctOFIE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2gLYSN5r0",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2gLYSN5r0",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2EgNVXu5r",
    opacity: 1,
    fill: "#9a1111",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2EgNVXu5r",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuv);
export default __webpack_public_path__ + "static/media/suv.53d8f6f188662d6476c1bd6d4c0e3e23.svg";
export { ForwardRef as ReactComponent };